import { render } from "./Sightings.vue?vue&type=template&id=d2547b4c"
import script from "./Sightings.vue?vue&type=script&lang=js"
export * from "./Sightings.vue?vue&type=script&lang=js"

import "./Sightings.vue?vue&type=style&index=0&id=d2547b4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__